import React from 'react';
import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import TableControls from 'components/base/TableControls/TableControls';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import {
  FakeButtonWrapper,
  FakeButton,
  FakeDropdown,
  FullScreenDropdownWrapper,
} from 'components/base/SkeletonLoader/FakeInteractive';
import Table from 'components/data-visualization/Table/Table';
import Row from 'components/data-visualization/Table/Row';
import getTableHeaders from './utils/getTableHeaders';
import { Head, Label } from 'components/data-visualization/Table/SortingHead';

import styled from 'styled-components/macro';
import useMedia from 'hooks/useMedia';
import {
  Header,
  TableRow,
  TableCell,
} from 'components/data-containers/PositionsTable/shared/PositionsTable.style';
import TableLoader from 'components/utility/ContentLoader/TableLoader/TableLoader';
import TableBody from 'components/data-visualization/Table/Body';

const TableWrapper = styled(Table)`
  margin: ${({ theme }): any => `${theme.spacing.xlarge} 0`};
`;

export default function ShazamTagSkeletonLoader(): JSX.Element {
  const isLargeScreen = useMedia('(min-width: 60em)');

  const toggleOptions = [
    { value: 'cities', label: 'Cities', active: true },
    { value: 'countries', label: 'Countries', active: false },
  ];

  const headers = getTableHeaders('cities');

  return (
    <GenericComponent
      title="Shazam Tags Per City"
      loading={true}
      success={false}
    >
      <AnimatedLoadingWrapper loading={true}>
        <TableControls>
          <div>{/*search*/}</div>
          {isLargeScreen && toggleOptions ? (
            <FakeButtonWrapper>
              {toggleOptions.map((option) => (
                <FakeButton key={option.value} active={option.active}>
                  {option.label}
                </FakeButton>
              ))}
            </FakeButtonWrapper>
          ) : (
            <FullScreenDropdownWrapper>
              <FakeDropdown>Cities</FakeDropdown>
            </FullScreenDropdownWrapper>
          )}
        </TableControls>

        <TableWrapper>
          {isLargeScreen && (
            <Head>
              <Row>
                {headers.map((header: any) => (
                  <Header key={header.value}>
                    <Label>{header.label}</Label>
                  </Header>
                ))}
              </Row>
            </Head>
          )}
          <TableBody>
            <TableLoader
              columnCount={headers.length}
              rowComponent={TableRow}
              cellComponent={TableCell}
            />
          </TableBody>
        </TableWrapper>
      </AnimatedLoadingWrapper>
    </GenericComponent>
  );
}
